import React from 'react';
import Container from '../../../../constants/Container';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess } from '../../../../constants/Toast';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import SelectInputBox from '../../../../constants/SelectInputBox';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleChangePhone, handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { YesNoOptions } from '../../../../constants/Options';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import { MdOutlinePhone } from 'react-icons/md';
import { CiLock } from 'react-icons/ci';
import { TfiEmail } from "react-icons/tfi";
import { PiUserCircleCheckThin, PiUserLight } from 'react-icons/pi';
import { HiOutlineKey } from 'react-icons/hi2';
import { authorValidationSchema } from '../../../../helpers/validation';

interface AuthorCreateFormViewProps {
    handleFormSuccess: () => void;
}

const AuthorCreateFormView: React.FC<AuthorCreateFormViewProps> = ({ handleFormSuccess }) => {

    const initialValues = {
        first_name: "",
        last_name: "",
        name_nep: "",
        is_superuser: "",
        username: "",
        phone_number: "",
        email: "",
        designation: "",
        designation_nep: "",
        sidedrawer: "",
        showmenu: "",
        menu: "",
        sub_menu: "",
        user_locked: "",
        locked_message: "",
        is_active: "",
        confirm_password: "",
        password: ""
    };

    const { values, errors, touched, resetForm, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        validationSchema: authorValidationSchema,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            formData.append("name_nep", values.name_nep);
            formData.append("is_superuser", values.is_superuser === "1" ? "true" : "false");
            formData.append("username", values.username);
            formData.append("phone_number", values.phone_number);
            formData.append("email", values.email);
            formData.append("locked_message", values.locked_message);
            formData.append("password", values.password);
            formData.append("designation", values.designation);
            formData.append("user_locked", values.user_locked === "1" ? "true" : "false");
            formData.append("is_active", values.is_active === "1" ? "true" : "false");
            try {
                await postDataToTheServer(AppURL.ApplicationURL + "app/author/user/add/create/view/", formData).then((res) => {
                    action.resetForm();
                    handleFormSuccess();
                    ToastSuccess(res?.message);
                    if (res?.status === 201) {
                        ToastSuccess(res?.message);
                    }
                    action.resetForm();
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    return (
        <Container padding={true}>

            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Author Add' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='first_name'
                            label='First Name'
                            handleChange={handleChange}
                            value={values.first_name}
                            error={errors.first_name}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter First Name'
                            touched={touched.first_name} />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='last_name'
                            label='Last Name'
                            handleChange={handleChange}
                            value={values.last_name}
                            error={errors.last_name}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter Last Name'
                            touched={touched.last_name} />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Name(Nepali)'
                            name='name_nep'
                            value={values.name_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'name_nep' })}
                            required={true}
                            handleBlur={handleBlur}
                            error={errors.name_nep}
                            placeholder={'Enter nepali name'}
                            touched={touched.name_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='username'
                            prefix={<PiUserLight />}
                            label='Username'
                            handleChange={handleChange}
                            value={values.username}
                            error={errors.username}
                            handleBlur={handleBlur}
                            required={true}
                            placeholder='Enter Username'
                            touched={touched.username} />
                    </Grid>
                   
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<MdOutlinePhone />}
                            name='phone_number'
                            handleChange={(e) => handleChangePhone(e, { setFieldValue, name: 'phone_number' })}
                            handleBlur={handleBlur}
                            value={values.phone_number}
                            error={errors.phone_number}
                            touched={touched.phone_number}
                            label='Phone Number'
                            placeholder='XXX-XXXXXXX'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='email'
                            prefix={<TfiEmail />}
                            name='email'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.email}
                            error={errors.email}
                            touched={touched.email}
                            label='E-mail'
                            placeholder='example@gmail.com'
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            label="Designation"
                            name='designation'
                            handleChange={handleChange}
                            value={values.designation}
                            error={errors.designation}
                            placeholder='Enter designation'
                            handleBlur={handleBlur}
                            touched={touched.designation}
                            required={false}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <NepaliInputBox
                            label='Designation(Nepali)'
                            name='designation_nep'
                            value={values.designation_nep}
                            handleChange={(e) => handleNepaliInputChange(e, { setFieldValue, name: 'designation_nep' })}
                            required={false}
                            handleBlur={handleBlur}
                            error={errors.designation_nep}
                            placeholder={'Enter designation name'}
                            touched={touched.designation_nep}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="User Locked"
                            options={YesNoOptions}
                            name='user_locked'
                            required={true}
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            placeholder='Select user locked'
                            value={values.user_locked}
                            touched={touched.user_locked}
                        />
                    </Grid>
                    {
                        values.user_locked ==="1" && <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            label="Locked Message"
                            prefix={<CiLock />}
                            name='locked_message'
                            handleChange={handleChange}
                            value={values.locked_message}
                            error={errors.locked_message}
                            placeholder='Enter locked message'
                            handleBlur={handleBlur}
                            touched={touched.locked_message}
                            required={false}
                        />
                    </Grid>
                    }
                    
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Super User"
                            options={YesNoOptions}
                            name='is_superuser'
                            required={true}
                            placeholder='Select Super User'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.is_superuser}
                            touched={touched.is_superuser}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label="Active"
                            options={YesNoOptions}
                            name='is_active'
                            required={true}
                            placeholder='Select Active User'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.is_active}
                            touched={touched.is_active}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='password'
                            label="Password"
                            name='password'
                            prefix={<HiOutlineKey />}
                            handleChange={handleChange}
                            value={values.password}
                            error={errors.password}
                            placeholder='Enter Password'
                            handleBlur={handleBlur}
                            touched={touched.password}
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='password'
                            label="Confirm Password"
                            prefix={<HiOutlineKey />}
                            name='confirm_password'
                            handleChange={handleChange}
                            value={values.confirm_password}
                            error={errors.confirm_password}
                            placeholder='Enter Confirm password'
                            handleBlur={handleBlur}
                            touched={touched.confirm_password}
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default AuthorCreateFormView